import { useState, useMemo } from 'react';

const STEP_VALUES = {
  SELECT_TARGET_MEMBER: 0,
  SELECT_REQUIRED_PROPERTIES: 1,
  CLAIMS_VISIBILITY: 2,
};

const PRODUCT_TYPE_NO_CLAIMS = [];

const useSteps = ({ productType }) => {
  const [step, setStep] = useState(STEP_VALUES.SELECT_TARGET_MEMBER);

  const isExistClaims = useMemo(() => {
    if (step === STEP_VALUES.SELECT_TARGET_MEMBER) {
      return false;
    }

    return !PRODUCT_TYPE_NO_CLAIMS.includes(productType);
  }, [productType, step]);

  const onNextStep = () => {
    if (isExistClaims) {
      if (step === STEP_VALUES.SELECT_TARGET_MEMBER) {
        setStep(STEP_VALUES.SELECT_REQUIRED_PROPERTIES);
      } else if (step === STEP_VALUES.SELECT_REQUIRED_PROPERTIES) {
        setStep(STEP_VALUES.CLAIMS_VISIBILITY);
      } else {
        return;
      }
    } else {
      if (step === STEP_VALUES.SELECT_TARGET_MEMBER) {
        setStep(STEP_VALUES.SELECT_REQUIRED_PROPERTIES);
      } else {
        return;
      }
    }
  };

  const onBackStep = () => {
    if (isExistClaims) {
      if (step === STEP_VALUES.SELECT_REQUIRED_PROPERTIES) {
        setStep(STEP_VALUES.SELECT_TARGET_MEMBER);
      } else if (step === STEP_VALUES.CLAIMS_VISIBILITY) {
        setStep(STEP_VALUES.SELECT_REQUIRED_PROPERTIES);
      }
      return;
    } else {
      if (step === STEP_VALUES.SELECT_REQUIRED_PROPERTIES) {
        setStep(STEP_VALUES.SELECT_TARGET_MEMBER);
      }
    }
  };

  const isTargetMemberStep = step === STEP_VALUES.SELECT_TARGET_MEMBER;

  return {
    step,
    isExistClaims,
    isRenderClaimsVisibility: isExistClaims,
    isTargetMemberStep,
    setStep,
    onNextStep,
    onBackStep,
  };
};

export default useSteps;